import instance from "api/apiClient";
import { apiRoutes } from "configs/apiRoutes";

export interface GetListPayload {
  page?: number;
  limit?: number;
  title?: string;
  isActive?: number;
}

export const getTagsListService = async (data: GetListPayload) => {
  try {
    const res = await instance.post(apiRoutes.tagsList, data);
    return res.data.items || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getTagsByIdsService = async (ids: number[]) => {
  try {
    const res = await instance.post(apiRoutes.tagsList, { ids });
    return res.data.items || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};
